import { useEffect, useState } from "react"

import { Box, Headline3, Img, Text, Button } from "ui-kit/components-branded/index"
import { AttachCard } from "modules/ClientAccount/components/AttachCard"
import { useScrollByUrlHash } from "modules/ClientAccount/hooks"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

interface Props {
    reFetchCardList: () => void
}

export function PaymentMethodNoCard({ reFetchCardList }: Props) {
    const [{ userAccount: clientUserAccount }] = useClientContext()
    const isB2b = clientUserAccount.is_b2b
    useScrollByUrlHash()
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    useEffect(() => {
        !isModalOpen && reFetchCardList()
    }, [isModalOpen])

    return (
        <Box data-test-id="clientacc-payment-method-block">
            <div className="payment-method__content" id="attach-card">
                <div className="payment-method__description">
                    <Headline3 className="payment-method__title">
                        Привяжите банковскую&nbsp;карту
                    </Headline3>
                    <Text className="payment-method__subtext">
                        {!isB2b ? (
                            <>Упростите процесс оплаты. Привязать можно только российскую карту.</>
                        ) : (
                            <>Привязать можно только российскую&nbsp;карту.</>
                        )}
                    </Text>
                    <div>
                        <Button
                            color="primary"
                            className="is-hidden-mobile"
                            onClick={() => setIsModalOpen(true)}
                        >
                            Привязать карту
                        </Button>
                    </div>
                </div>
                <Img
                    className="payment-method__illustration"
                    src="card-widget-pablita.svg"
                    width={213}
                    height={120}
                />
                <Button
                    color="primary"
                    isResponsive
                    className="is-hidden-desktop is-hidden-tablet"
                    onClick={() => setIsModalOpen(true)}
                >
                    Привязать карту
                </Button>
            </div>
            <AttachCard isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
        </Box>
    )
}
